var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResendinvit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5674_33268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308362 5.58207C-0.133338 5.83402 -0.0922949 6.50589 0.378722 6.7012L3.12078 7.84377V9.86133C3.12078 10.2148 3.40613 10.5 3.75988 10.5C3.94946 10.5 4.12926 10.416 4.25044 10.2695L5.46218 8.81837L7.88371 9.82618C8.2531 9.98047 8.68112 9.73829 8.74171 9.34376L9.99254 1.21882C10.0297 0.982493 9.92609 0.744213 9.72869 0.609449C9.53129 0.474684 9.27331 0.462966 9.06419 0.582105L0.308362 5.58207ZM1.32662 6.08011L8.00098 2.26959L3.70906 7.06253L3.73252 7.08206L1.32662 6.08011ZM7.8759 8.80861L4.61982 7.45119L8.80425 2.7774L7.8759 8.80861Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5674_33268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendinvit);
export default __webpack_public_path__ + "static/media/Resendinvit.2fc7f39c6d71705969001e48ccfdd828.svg";
export { ForwardRef as ReactComponent };